var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoSendDeliveredMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "78px",
    viewBox: "0 0 62 78",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "done-marker-drop@2x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-27.3%",
    y: "-21.1%",
    width: "154.5%",
    height: "146.1%",
    filterUnits: "objectBoundingBox",
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.15 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-63.7%",
    width: "185.7%",
    height: "227.4%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Delivered",
    transform: "translate(-128.000000, -321.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icoPickupPin",
    transform: "translate(137.000000, 330.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5,56.2725692 C24.4329966,56.2725692 26,56.4329966 26,54.5 C26,52.5670034 24.4329966,51.5668307 22.5,51.5668307 C20.5670034,51.5668307 19,52.5670034 19,54.5 C19,56.4329966 20.5670034,56.2725692 22.5,56.2725692 Z",
    id: "Drop-shadow",
    fillOpacity: 0.4,
    fill: "#000000",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pin"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,0 C34.0287619,0 43.8027752,9.65110742 43.9970526,21.6361112 L44,22 C44,32.7291049 36.3217494,41.6643718 26.1577096,43.6078208 C26.1005058,43.742103 26.0484679,43.8727229 26,44 C25.3483824,45.7111533 24.5236592,48.4053688 23.5258304,52.0826464 L23.3946783,52.5678613 C23.2511241,53.1011518 22.7024331,53.4170955 22.1691427,53.2735413 C21.8357416,53.1837945 21.5722239,52.9284056 21.4720781,52.5979793 C20.2773727,48.656106 19.3607683,45.7901129 18.7222648,44 C18.6921973,43.9157026 18.6601563,43.8299388 18.6261417,43.7427085 C8.07714391,42.1194953 0,33.0051974 0,22 C0,9.97123815 9.65110742,0.197224763 21.6361112,0.00294737144 L22,0 Z",
    id: "Main-pin",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Main-pin-color",
    fill: "#F7AF18",
    x: 2,
    y: 2,
    width: 40,
    height: 40,
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Border-pin-color",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    x: 1.5,
    y: 1.5,
    width: 41,
    height: 41,
    rx: 20.5
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.7755196 L16.9896884,28.9992585 C17.3673096,29.3945927 17.9924179,29.4133927 18.3931143,29.0414662 L30.7328917,17.5876834 L30.7328917,17.5876834",
    id: "Path-2",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    strokeLinecap: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoSendDeliveredMarker);
export default __webpack_public_path__ + "static/media/go-send-delivered-marker.5c6ed02de05ee43d63611caf978301f4.svg";
export { ForwardRef as ReactComponent };